module.exports = __webpack_public_path__ + "static/media/78.5227c7ba.jpg";